/**
 * @generated SignedSource<<f900069b9d6042817a53108542a3ecac>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { InlineFragment, ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type sharedMessageHelpers_messages$data = {
  readonly items: ReadonlyArray<{
    readonly note: {
      readonly serviceId: string | null;
      readonly content: {
        readonly message: string | null;
      } | null;
      readonly anchors: ReadonlyArray<{
        readonly serviceId: string | null;
        readonly content: {
          readonly message: string | null;
        } | null;
      } | null> | null;
    } | null;
  } | null> | null;
  readonly " $fragmentType": "sharedMessageHelpers_messages";
};
export type sharedMessageHelpers_messages$key = {
  readonly " $data"?: sharedMessageHelpers_messages$data;
  readonly " $fragmentSpreads": FragmentRefs<"sharedMessageHelpers_messages">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "sharedMessageHelpers_messages"
};

(node as any).hash = "c7cf202a5022a6975161e073e3b8da36";

export default node;
